import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { Button } from "./ui";
import { banReason, copyText } from "../lib/banTools";

/** Copie le motif standard sans obliger à retaper sa formulation dans Discord. */
export function BanReasonPicker() {
  const [copied, setCopied] = useState(false);
  const [copyFailed, setCopyFailed] = useState(false);

  const copy = async () => {
    try {
      await copyText(banReason());
      setCopied(true);
      setCopyFailed(false);
      window.setTimeout(() => setCopied(false), 1600);
    } catch {
      setCopied(false);
      setCopyFailed(true);
      window.setTimeout(() => setCopyFailed(false), 2500);
    }
  };

  return (
    <div className="ban-reason-picker">
      <Button variant="secondary" onClick={() => void copy()}>
        {copied ? <Check size={15} /> : <Copy size={15} />} {copied ? "Motif copié" : copyFailed ? "Copie impossible" : "Copier le motif"}
      </Button>
    </div>
  );
}
